export enum RouteName {
  Home = "Home",
  Service = "Service",
  ServiceStatus = "ServiceStatus",
  EventList = "EventList",
  EventDetail = "EventDetail",
  Redirect = "Redirect",
  NotFound = "NotFound",
  AccessError = "AccessError",
  NotificationPolicy = "NotificationPolicy",
  ImportantOld = "ImportantOld",
  Summary20230220 = "Summary20230220",
  Powermsp20230220 = "Powermsp20230220",
}
